module.exports = __webpack_public_path__ + "static/media/Rene Bieder - Campton-Book.f5c1a700.otf";